import { getQuotationsByFileIdQuery } from './getQuotationsByFileIdQuery';
import { setQuoteClientAnswerCommand } from './setQuoteClientAnswerCommand';
import { updateQuotationSparePartSelectionCommand } from './updateQuotationSparePartSelectionCommand';

export const CommonRepairerService = {
  getQuotationsByFileIdQuery,
  setQuoteClientAnswerCommand,
  updateQuotationSparePartSelectionCommand,
};
